import React, { useState } from 'react';
import { RowComponentProps } from 'react-window';
import { ActiveReviewNote } from '../shared';
import styles from './index.module.scss';
import Card from '@components-clean/core/card';
import { useTranslation } from '@hooks/index';
import { stringDateWithoutTimeFromUtc } from '@utils/convertor';

export type ListState = {
    getNote: (index: number) => ActiveReviewNote | undefined;
};
type Props = RowComponentProps<{
    listState: ListState;
}>;

const ActiveReviewNotesListRow = ({ index, listState, style }: Props) => {
    const { t } = useTranslation('sm', {
        keyPrefix: 'monitoringToolkit.activeReviewTab.tabs.summary.notes.notesList.item',
    });
    const [collapsed, setCollapsed] = useState(false);

    // Try to get data for row. Exit if unable.
    const note = listState.getNote(index);
    if (note == null) {
        return null;
    }

    const formattedObservationDate = stringDateWithoutTimeFromUtc(note.observationDate, 'DD-MMM-yyyy');

    const formattedCreatedDate = stringDateWithoutTimeFromUtc(note.createdDate, 'DD-MMM-yyyy');
    const formattedUpdatedDate = stringDateWithoutTimeFromUtc(note.updatedDate, 'DD-MMM-yyyy');

    return (
        <li style={style}>
            <Card
                key={note.recordId}
                data-testid={`active-review-note-${note.recordId}`}
                className={styles.noteCard}
                title={
                    <div className={styles.title}>
                        {/* SubjectNumber will be empty if note is not for a specific subject */}
                        {note.subjectNumber && (
                            <>
                                <span>Subject: {note.subjectNumber}</span>
                                <span>-</span>
                            </>
                        )}
                        <span>Date: {formattedObservationDate}</span>

                        {collapsed && (
                            <>
                                <span>-</span>
                                <span>{note.text.substring(0, 20)}</span>
                            </>
                        )}
                    </div>
                }
                collapsible
                collapsed={collapsed}
                onCollapsedChange={(c) => setCollapsed(c)}
                padding="none"
            >
                <div className={styles.noteCardBody}>{note.text}</div>

                <div className={styles.noteCardFooter}>
                    <div className={styles.noteCardFooterTitle}>{t('created')}</div>
                    <div className={styles.noteCardFooterValue}>
                        {formattedCreatedDate} {t('by')} {note.createdBy}
                    </div>
                    <div className={styles.noteCardFooterTitle}>{t('updated')}</div>
                    <div className={styles.noteCardFooterValue}>
                        {formattedUpdatedDate} {t('by')} {note.updatedBy}
                    </div>
                </div>
            </Card>
        </li>
    );
};

export default ActiveReviewNotesListRow;
